import Vue from 'vue';
import GamePortal from './App.vue';

Vue.component(GamePortal);
export default { GamePortal };

